<template>
  <BaseSectionContainer
    v-if="curation && page"
    tag="div"
    size="middle"
    class="jps-curation-footer"
  >
    <dl class="jps-credit is-size-7 text-center" v-if="page.date">
      <dt class="jps-section-heading heading-page-metadata">{{ ls(dapLangGlobal.lastUpdated) }}</dt>
      <dd>{{ ldate(page.date) }}</dd>
    </dl>
  </BaseSectionContainer>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

const { ls, ldate } = useI18n()

interface Props {
  curation: Curation
  page: Page
}
const props = withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-curation-footer {
  margin: 6rem auto 3rem;
  //max-width: lcuration-content-width;
  @include is-mobile {
    width: 100%;
    padding: 1rem;
    margin: 0;
  }
  .jps-credit {
    dt:last-of-type {
      margin-top: 2rem;
    }
    dd {
      margin-bottom: 0.5rem;
    }
    .tag {
      margin: 0.5rem 0 0 0;
      padding: 0.25rem 1rem;
      border-radius: 1rem;
    }
  }
  .jps-curation-footer-org {
    margin-top: 3rem;
    h1 {
      margin: 1rem;
    }
  }
  .jps-curation-foot-attr {
    text-align: center;
    font-size: 0.875rem;
  }
}
</style>
